import React, { Component } from 'react'
import { store } from '../../redux/store';
import { connect } from 'react-redux';
import { SET_PAGE_TITLE, SET_REPORT_LIST } from '../../redux/types';
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { cardTitle, roseColor } from "assets/jss/material-dashboard-pro-react.jsx";
import { cleanReportName } from '../../helpers';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { withStyles } from '@material-ui/core';
import Api from '../../api/Api.js';
import ReportEndpoints from '../../api/ReportEndpoints';
import ReactSelect from '../../components/Select/ReactSelect';
import Button from '../../components/CustomButtons/Button';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CustomInput from '../../components/CustomInput/CustomInput';
import DataTable from '../../components/Table/DataTable';

const styles = {
    cardTitle,
    cardTitleWhite: {
        ...cardTitle,
        color: "#FFFFFF",
        marginTop: "0"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: ".875rem"
    },
    cardCategory: {
        color: "#999999",
        marginTop: "10px"
    },
    icon: {
        color: "#333333",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    },
    testimonialIcon: {
        marginTop: "30px",
        "& svg": {
            width: "40px",
            height: "40px"
        }
    },
    cardTestimonialDescription: {
        fontStyle: "italic",
        color: "#999999"
    }
};

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Report Name",
        options: {
            filter: true,
            sort: true,
        }
    }
]

class FtpReports extends Component {

    constructor(props) {
        super(props);

        var currentServer = props.ftps.find(x => x.id === parseInt(props.match.params.id));
        store.dispatch({ type: SET_PAGE_TITLE, payload: currentServer.name })

        this.state = {
            server: currentServer,
            selectedReport: { label: 'None', value: '' },
            loading: (props.reports && props.reports.length > 0),
            path: '/',
            pathState: '',
            sync: false
        }
    }

    componentDidMount() {
        Api.get(ReportEndpoints.list)
            .then(({ data }) => {
                this.setState({ loading: false }, () => {
                    store.dispatch({ type: SET_REPORT_LIST, payload: data })
                });
            })
            .catch((e) => {
                console.error(e);
            })
    }

    render() {
        const { server } = this.state;
        const { reports, classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="success" text>
                            <CardText color="success">
                                <h4 className={classes.cardTitleWhite}>{server.name} Reports</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <ReactSelect
                                options={
                                    reports && reports.length > 0 ?
                                        [{ label: 'None', value: '' }].concat(reports.map(rep => ({ label: cleanReportName(rep.name), value: rep.id })))
                                        :
                                        [{ label: 'None', value: '' }]
                                }
                                onChange={(value) => {
                                    var reportFtp = server.reports.find(x => x.report_id === value.value);

                                    if (reportFtp)
                                        this.setState({ selectedReport: value, path: reportFtp.path, pathState: 'success', sync: reportFtp.sync })
                                    else
                                        this.setState({ selectedReport: value, path: '/', pathState: '', sync: false })
                                }
                                }
                                placeholder="Please Select a Report..."
                                value={this.state.selectedReport}
                                isSearchable
                                isLoading={this.state.loading}
                                isDisabled={this.state.loading}
                            />
                            {
                                this.state.selectedReport.value ?
                                    [
                                        <hr key="hr" />,
                                        <CustomInput
                                            key="path"
                                            success={this.state.pathState === "success"}
                                            error={this.state.pathState === "error"}
                                            labelText={
                                                <span>
                                                    Path <small>(required)</small>
                                                </span>
                                            }
                                            id="path"
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            //labelProps={{ shrink: true }}
                                            inputProps={{
                                                onChange: event => this.setState({ path: event.target.value, pathState: (event.target.value) ? "success" : "error" }),
                                                value: this.state.path,
                                                onKeyPress: ({ nativeEvent }) => {
                                                    if (nativeEvent.keyCode == 13) {
                                                        //this.submit();
                                                    }
                                                }
                                            }}
                                        />,
                                        <div key="sync" className={classes.block}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={this.state.sync}
                                                        onChange={() => this.setState({ sync: !this.state.sync })}
                                                        classes={{
                                                            switchBase: classes.switchBase,
                                                            checked: classes.switchChecked,
                                                            icon: classes.switchIcon,
                                                            iconChecked: classes.switchIconChecked,
                                                            bar: classes.switchBar
                                                        }}
                                                    />
                                                }
                                                classes={{
                                                    label: classes.label
                                                }}
                                                label="Sync Directory"
                                            />
                                        </div>,
                                        <div key="finalize" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <Button round color="rose">
                                                Apply Report Upload
                                            </Button>
                                        </div>
                                    ]
                                    :
                                    null
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <DataTable
                        title={"Reports Linked to Server"}
                        data={
                            reports.filter(x => server.reports.some(y => y.report_id === x.id))
                                .map(rep => [rep.id, cleanReportName(rep.name)])
                        }
                        columns={columns}
                        options={{
                            onRowClick: (row) => {
                                var selectedRep = server.reports.find(x => x.report_id == row[0]);
                                this.setState({ selectedReport: { label: row[1], value: parseInt(row[0]) }, sync: Boolean(selectedRep.sync), path: selectedRep.path, pathState: 'success' })
                            }
                        }}
                        rowPointers
                    />
                </GridItem>
            </GridContainer>
        )
    }
}

const mapStateToProps = ({ reports }) => ({ ftps: reports.ftps, reports: reports.list })

export default withStyles({ ...extendedFormsStyle, ...styles })(connect(mapStateToProps)(FtpReports));